/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Value_Memory_TitleInputs */



/**
* | output |
* | --- |
* | "Keeping track of every conversation partner" |
*
* @param {Onboarding_Value_Memory_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_value_memory_title = /** @type {((inputs?: Onboarding_Value_Memory_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Value_Memory_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geheugen per gesprekspartner")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une mémoire par interlocuteur")
	return /** @type {LocalizedString} */ ("Keeping track of every conversation partner")
});